import { PastResponse } from 'types';

export const MOCK_RESPONSE_STANDARD_PAST_RESPONSE_DOCUMENT = {
  id: 1,
  responseId: 1,
  name: 'uploaded response document.doc',
  dateCreated: new Date('2021-06-06'),
  dateModified: new Date('2021-06-06'),
  response: true,
};

export const MOCK_RESPONSE_PAST_RESPONSE_SUPPORTINGDOCUMENT = {
  id: 1,
  responseId: 1,
  name: 'uploaded response supporting documents.doc',
  dateCreated: new Date('2021-06-06'),
  dateModified: new Date('2021-06-06'),
  response: true,
};

export const MOCK_RESPONSE_STANDARD_PAST_RESPONSE: PastResponse = {
  id: 1,
  type: '1',
  typeDefinition: 'Non-Statutory',
  responseDate: new Date('2022-02-02'),
  response: 'Test response',
  reasonForLateResponse: 'None',
  reasonForLateResponseDetail: 'None',
  document: MOCK_RESPONSE_STANDARD_PAST_RESPONSE_DOCUMENT,
  supportingDocuments: [MOCK_RESPONSE_PAST_RESPONSE_SUPPORTINGDOCUMENT],
};
